/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { useFormContext } from '@jalik/react-form'
import { useMemo } from 'react'
import { Text, TextProps } from '@mantine/core'

function FormErrors (props: TextProps) {
  const { submitError } = useFormContext()

  const message = useMemo(() => {
    if (!submitError) {
      return null
    }
    return submitError.message
  }, [submitError])

  return message != null
    ? <Text {...props} c="red">
      {message}
    </Text>
    : null
}

export default FormErrors
